<template>
    <div class="voice-note">
        <div :class="[{'flex-column align-start':miniSize},{'align-center':!miniSize},'d-flex']">
            <div class="fw-600 me-3">음성 메모</div>
            <div class="fs-14 primary--text" :class="{'error--text':!play}">{{duration}}</div>
        </div>
        <div>
            <v-btn icon class="btn-play" @click="control"><Play :play="play"/></v-btn>
        </div>
        <!-- <CloseBtn v-if="isClose" :method="'voiceDelete'" @delete="voiceDelete"/> -->
        <CloseBtn v-if="isClose" @delete="voiceDelete"/>
    </div>
</template>
<script>
import Play from '@/components/icons/Play'
import CloseBtn from '@/components/btns/CloseBtn'
import utils from "@/utils/utils";
// import utils from '../../utils/utils.js'
export default {
    // props: ["miniSize", "isClose", "voiceNote", "voiceFileName"],
  props:{
    miniSize: Boolean,
    voiceNote: String,
    voiceFileName: String,
    isClose:{
          type: Boolean,
          default: true
      }
  },

    data: ()=> ({
        play: true,
        audio: '',
        duration:'',
    }),
    components:{
        Play,
        CloseBtn,
    },
    watch: {
        audio() {
            console.log("this.audio watch: ", this.audio)
        },
    },
    mounted () {
      console.log('voiceFileName: ', this.voiceFileName)
      this.audio = new Audio(utils.File.getDownUrl(this.voiceFileName))
      this.audioInit()
    },
    methods:{
        control(){
            this.play = !this.play;
            if(!this.play){
                this.audioPlay()
            }else{
                this.audioPause()
            }
        },
        audioInit(){
            this.audio.onloadeddata = ()=>{
                console.log("this.audio duration:", this.audio.duration);

                // 총시간 셋팅
                this.secToTime(this.audio.duration)
                this.audio.loop = false
            }
        },
        audioPlay(){
            this.audio.play()

            this.audio.addEventListener('timeupdate', this._handleTimeupdate);
            // console.log("this.timeupdate : ", this.audio.timeupdate)

            this.audio.addEventListener('ended', this._handleEnded);
            // console.log("this.ended : ", this.audio.ended)
        },
        audioPause(){
            this.audio.pause()
            this.audio.removeEventListener('ended', this._handleEnded);
        },
        voiceDelete(){
            this.$emit('voiceDelete')
        },
        _handleEnded () {   //재생종료
            console.log("this.ended")
            this.audio.pause()
            this.play = true
            this.audio.removeEventListener('ended', this._handleEnded);
            this.audio.removeEventListener('timeupdate', this._handleTimeupdate);
        },
        _handleTimeupdate () {  //재생시간 업데이트

            this.secToTime(this.audio.currentTime)
        },
        secToTime(duration) {
            // duration = 3599
            var seconds = Math.floor(duration % 60),
                minutes = Math.floor((duration / 60) % 60)

            minutes = (minutes < 10) ? "0" + minutes : minutes
            seconds = (seconds < 10) ? "0" + seconds : seconds

            this.duration = minutes + ":" + seconds
            // console.log("time", minutes + ":" + seconds)
        }
    }
}
</script>
<style lang="scss" scoped>
.voice-note{
    position: relative;
    height: 90px;
    border: 1px solid #7260FF;
    border-radius: $border-radius-root;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 35px 20px 20px;

}
</style>
